import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

interface IStatCardProps {
  label: string;
  value: number | undefined;
  subtitle?: string;
  className?: string;
}

export function StatCard({ label, value, subtitle, className }: IStatCardProps) {
  const isLoading = value === undefined;

  return (
    <Card className={cn('flex flex-col', className)}>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">{label}</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <>
            <Skeleton className="h-9 w-20 mb-1" />
            {subtitle !== undefined && <Skeleton className="h-4 w-28" />}
          </>
        ) : (
          <>
            <p className="text-3xl font-bold text-foreground">{value}</p>
            {subtitle !== undefined && (
              <p className="text-xs text-muted-foreground mt-1">{subtitle}</p>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
}
